import { PreferenceType } from './../../../../shared/models/enum/preferenceType';
import { LogService } from './../../../../shared/services/log.service';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeAdresseTEMPOST } from '../models/TypeAdresseTEMPOST';
import { MapaINControlNames } from '../../../mapa/mapa-initial/service/mapaINControleNames';
import { CTRL_1222 } from '../../../validators/1222/ctrl1222';
import { CTRL_TRIM } from '../../../validators/TRIM/ctrlTRIM';
import { Step7 } from '../../../../shared/models/component-messages/diveIN/step7';
import { DivINControlNames } from '../../diversInitial/services/DivINControleNames';
import { CTRL_1216 } from '../../../validators/1216/ctrl1216';
@Component({
  selector: 'app-type-adresseTEMPOST',
  templateUrl: './type-adresseTEMPOST.component.html'
})
export class TypeAdresseTEMPOSTComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeAdresseTEMPOST';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  public siretCtrName: string;

  @Input() libelle: TypeAdresseTEMPOST;

  private LOG: LogService = new LogService(TypeAdresseTEMPOSTComponent);
  public typeFacturation = PreferenceType.FACTURATION;

  public rg1 = '_STEP_ID_10_' + CTRL_1222.id + '_1';
  public rg2 = 'CTRL_FACTURATION';
  public rg3 = '_STEP_ID_10_' + CTRL_TRIM.id + '_1';
  public rg4 = '_STEP_ID_10_' + CTRL_1216.id + '_1';

  public step7 = new Step7();

    public optionsSelect: any[];
    public optionsSelectType = 'PAYS';

  constructor(private autoCompleteService: AutoCompleteService) { }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.parentForm.addControl(this.rg1, new FormControl({ rgCtrls: DivINControlNames.getCtrl_1222Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: DivINControlNames.getCtrl_facturationNames_json() }));
    this.parentForm.addControl(this.rg3, new FormControl({ rgCtrls: DivINControlNames.getCtrl_TrimNames_json() }));
    this.parentForm.addControl(this.rg4, new FormControl({ rgCtrls: DivINControlNames.getCtrl_1222Names_json() }));
    this.siretCtrName = this.getUid() + '_SepAtt_siret';
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

}

